module.exports = __webpack_public_path__ + "static/media/Illus-PlateFull@2x.2014a50d.png";